<template>
    <loading v-if="loading"></loading>
<!--    <div v-if="loading" class="text-center"><img src="/loading.svg" /><p>Loading...</p></div>-->
    <div v-else>


        <add-post-modal ref="addPostModal" :status="newStatusId" :section="newSectionId" :category="selectedCategoryId" :categories="categories" :statuses="statuses" :sections="sections" :is-admin="isAdmin" :is-admin-form="isAdminForm" :tab-type="tab.type" :modal-title="newPostModalTitle" @post-added="onPostAdded"></add-post-modal>



        <template v-if="isAdmin">
            <onboarding-feedback-tab
                v-if="tab.type === 'list'"
                :tab="tab"
                @onboarding-done="handleOnboardingDone"
                @onboarding-dismissed="handleOnboardingDismissed"
                @create-feedback="openAddPostModal(defaultNewStatusId, defaultNewSectionId)"
                @create-product-vision="openUrl('/admin/product_vision')"
                @ai-prioritization="openUrl('/admin/ai_prioritization')"
                @traditional-prioritization="openUrl('/admin/prioritization')"
            />

            <onboarding-roadmap-tab
                v-if="tab.type === 'kanban'"
                :tab="tab"
                @onboarding-done="handleOnboardingDone"
                @onboarding-dismissed="handleOnboardingDismissed"
                @generate-roadmap-posts="openUrl(`/admin/posts/bulk?status_id=${statuses[0].id}&show_ai=true`)"
                @add-column="addSectionAfterId=null;showNewStatusModal = true"
            />

            <onboarding-changelog-tab
                v-if="tab.type === 'changelog'"
                :tab="tab"
                @onboarding-done="handleOnboardingDone"
                @onboarding-dismissed="handleOnboardingDismissed"
                @generate-changelog-posts="openUrl(`/admin/posts/bulk?status_id=${statuses[0].id}&show_ai=true`)"
                @git2log="openUrl('/admin/git2log')"
                @get-embed-code="goToCreateWidget('embed')"
                @copy-changelog-link="copyLink(tab.url)"
            />

            <onboarding-knowledgebase-tab
                v-if="tab.type === 'knowledgebase'"
                :tab="tab"
                @onboarding-done="handleOnboardingDone"
                @onboarding-dismissed="handleOnboardingDismissed"
                @generate-article-with-ai="openUrl(`/admin/posts/bulk?status_id=${statuses[0].id}&show_ai=true`)"
                @add-topic="addKnowledgeBaseTopic"
                @get-embed-code="goToCreateWidget('embed')"
                @copy-knowledge-base-link="copyLink(tab.url)"
            />
        </template>






        <b-card class="mb-3"  v-if="(tab.display_page_title || tab.display_page_description) || isAdmin">
            <div class="d-md-flex align-items-baseline w-100">
                <h1 class="flex-grow-1" v-if="tab.display_page_title">{{tab.page_title}}</h1>

                <div v-if="isAdmin">
                    <AddSectionModal :is-modal-visible="showNewSectionModal" @hide="showNewSectionModal = false" :tab-id="tab.id" :after-section-id="addSectionAfterId" @section-created="handleNewSectionCreatedButton" />

                    <add-status-modal
                        v-if="!tab.saved_query_id"
                        :is-modal-visible="showNewStatusModal"
                        @hide="showNewStatusModal = false"
                        :tab-id="tab.id"
                        :after-status-id="addStatusAfterId"
                        @status-created="handleStatusCreated"
                    />

<!--                    <a href="#" data-productlift-feedback="4e5b68ca-0bdd-4e6e-a946-0a9103bf9446" class="small mr-2" data-toggle="tooltip" title="Admins can share their feedback with the ProductLift team here."><i class="bi bi-chat-left"></i> Send feedback</a>-->
                    <div class="btn-group">
                        <!-- Primary Actions Dropdown -->
                        <b-dropdown id="primary-actions" variant="outline" right v-b-tooltip title="Add posts">
                            <template #button-content>
                                <i class="bi bi-plus-circle"></i> Add post
                            </template>
                            <b-dropdown-item v-if="tab.type !== 'knowledgebase'" @click.prevent="openAddPostModal(statuses[0].id, null, true)">Add one</b-dropdown-item>
                            <b-dropdown-item :href="`/admin/posts/bulk?status_id=${statuses[0].id}`">Add in bulk <i class="bi bi-stars"></i></b-dropdown-item>
                            <b-dropdown-item :href="'/admin/posts/post_import_file'">Import from file</b-dropdown-item>
                        </b-dropdown>

                        <!-- View Options -->
                        <b-button variant="outline" :href="'/admin/posts/all?tab_id=' + tab.id" v-b-tooltip title="List view">
                            <i class="bi bi-card-list"></i>
                        </b-button>

                        <!-- Layout Button -->
                        <b-button
                            v-if="tab.type === 'kanban' && column_names === 'section' && !tab.saved_query_id"
                            variant="outline"

                            @click="addSectionAfterId=null;showNewSectionModal = true"
                            v-b-tooltip
                            title="Add section column">
                            <i class="bi bi-layout-sidebar-inset"></i>
                        </b-button>
                        <b-button
                            v-if="tab.type === 'kanban' && column_names === 'status' && !tab.saved_query_id"
                            variant="outline"

                            @click="addSectionAfterId=null;showNewStatusModal = true"
                            v-b-tooltip
                            title="Add status column">
                            <i class="bi bi-layout-sidebar-inset"></i>
                        </b-button>

                        <!-- More Actions -->
                        <b-dropdown id="more-actions" variant="outline" right v-b-tooltip title="More">
                            <template #button-content>
                                <i class="bi bi-three-dots"></i>
                            </template>
                            <b-dropdown-item @click="copyLink(tab.url)">Copy link</b-dropdown-item>
                            <b-dropdown-item @click="goToCreateWidget('sidebar')">Create Sidebar Widget</b-dropdown-item>
                            <b-dropdown-item @click="goToCreateWidget('embed')">Create Embed Widget</b-dropdown-item>
                            <b-dropdown-item :href="'/sitemap/tab/' + tab.id">Get XML Sitemap</b-dropdown-item>
                            <b-dropdown-item :href="'/rss/tab/' + tab.id">Get RSS Feed</b-dropdown-item>
                            <b-dropdown-item :href="'/admin/settings/tabs_statuses#tab_' + tab.slug">Settings</b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
            <div>
                <div class="tab_description" v-html="tab.formatted_page_description" v-if="tab.display_page_description"></div>
                <div v-if="isAdmin && tab.saved_query_id">
                    <b-alert show variant="warning" class="small">
                        This tab uses a custom query. Set it in <i>Tab Settings → Advanced</i> or save a new query on the <i>All Posts</i> page. Adding a post does not automatically add it to the whole query filters.
                    </b-alert>

                </div>
                <div v-if="isAdmin" class="mt-2 d-flex justify-content-between">
                    <div>
                        <template v-if="totalPosts < 3">
                            <a href="/admin/posts/post_import_file" class="btn btn-outline btn-sm" v-b-tooltip title="Import posts from various sources, including Excel and CSV files."><i class="bi bi-cloud-arrow-down text-primary mr-2"></i> Import Posts</a>
                        </template>
                        <template v-if="tab.type === 'changelog'">
                            <a href="/admin/git2log" class="btn btn-outline btn-sm" v-b-tooltip title="Turn git commits into your changelog with AI."><i class="bi bi-stars text-primary mr-2"></i> Git2Log</a>
                        </template>
                        <template v-if="tab.type === 'list'">
                            <a href="/admin/ai_prioritization" class="btn btn-outline btn-sm mr-2" v-b-tooltip title="Let AI find the 5 best posts to focus on."><i class="bi bi-stars text-primary mr-2"></i> Prioritize with AI</a>
                            <a href="/admin/prioritization" class="btn btn-outline btn-sm" v-b-tooltip title="Prioritize posts with a score framework like RICE."><i class="bi bi-pie-chart text-primary mr-2"></i> Score-Based Prioritization</a>
                        </template>
                    </div>
                </div>
            </div>

<!--
    Here is room for specific actions depending on tab
    Git2Log for example
    <a href="{{ route('prioritize') }}" class="list-group-item list-group-item-action @if (Request::routeIs('prioritize')) active @endif"><i class="bi bi-funnel"></i> Prioritize</a>
-->
        </b-card>






        <category-filter-columns
            v-if="tab.display_category_bar_columns"
            :categories="categories"
            :selected-category-id="selectedCategoryId"
            :is-admin="isAdmin"
            @category-selected="onCategorySelected"
        />

        <div class="d-flex justify-content-between tab-buttons-header">
            <div v-if="tab.display_feedback_form === 'left'" class="d-none d-md-block" style="min-width: 300px; max-width: 400px; margin-right: 30px;">
                <PostForm :status="newStatusId" :section="newSectionId" :categories="categories" :category="selectedCategoryId" :is-admin="isAdmin" @post-added="onPostAdded" />
            </div>

            <div class="flex-grow-1">
                <div class="filter-bar" v-if="tab.type !== 'knowledgebase'">
                    <!-- Main container with responsive flex wrapping -->
                    <div class="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-3">
                        <!-- Left side filters group -->
                        <div class="d-flex flex-wrap gap-2 flex-grow-1">
                            <!-- Category filter -->
                            <category-filter-row
                                v-if="displayFilterRow"
                                :categories="categories"
                                :selected-category-id="selectedCategoryId"
                                :is-admin="isAdmin"
                                @category-selected="onCategorySelected"
                                class="flex-shrink-0"
                            /><!--                                :force-small-variant="isSmallVariant"-->

                            <!-- Version dropdown -->
                            <b-dropdown
                                v-if="hasVersions"
                                variant="outline"
                                class="flex-shrink-0"
                            >
                                <template #button-content>
                                    <i class="fa fa-tag"></i> Version: {{ selectedVersion || 'All' }}
                                </template>
                                <b-dropdown-item @click="setVersion(null)">All</b-dropdown-item>
                                <b-dropdown-item
                                    v-for="version in uniqueVersions"
                                    :key="version"
                                    @click="setVersion(version)"
                                    :active="selectedVersion === version"
                                >
                                    {{ version }}
                                </b-dropdown-item>
                            </b-dropdown>

                            <!-- Release dropdown -->
                            <b-dropdown
                                v-if="hasReleases"
                                variant="outline"
                                class="flex-shrink-0"
                            >
                                <template #button-content>
                                    <i class="fa fa-cube"></i> Release: {{ selectedRelease || 'All' }}
                                </template>
                                <b-dropdown-item @click="setRelease(null)">All</b-dropdown-item>
                                <b-dropdown-item
                                    v-for="release in uniqueReleases"
                                    :key="release"
                                    @click="setRelease(release)"
                                    :active="selectedRelease === release"
                                >
                                    {{ release }}
                                </b-dropdown-item>
                            </b-dropdown>

                            <!-- Platform dropdown -->
                            <b-dropdown
                                v-if="hasPlatforms"
                                variant="outline"
                                class="flex-shrink-0"
                            >
                                <template #button-content>
                                    <i class="fa fa-desktop"></i> Platform: {{ selectedPlatform || 'All' }}
                                </template>
                                <b-dropdown-item @click="setPlatform(null)">All</b-dropdown-item>
                                <b-dropdown-item
                                    v-for="platform in uniquePlatforms"
                                    :key="platform"
                                    @click="setPlatform(platform)"
                                    :active="selectedPlatform === platform"
                                >
                                    {{ platform }}
                                </b-dropdown-item>
                            </b-dropdown>

                            <!-- Sort dropdown -->
                            <b-dropdown
                                v-if="tab.display_sort"
                                variant="outline"
                                id="tabSortDropdown"
                                class="flex-shrink-0"
                                style="min-width: 50px;"
                            >
                                <template #button-content>
                                    <i :class="getSortIcon()"></i> Sort
                                </template>
                                <b-dropdown-item
                                    v-for="(label, field) in sortOptions"
                                    :key="field"
                                    @click="setOrder(field)"
                                    :active="orderBy === field"
                                >
                                    {{ label }} <i class="bi" :class="getSortDirectionIcon(field)"></i>
                                </b-dropdown-item>
                            </b-dropdown>
                        </div>

                        <!-- Right side actions group -->
                        <div class="d-flex flex-wrap gap-2 align-items-center ms-auto">
                            <!-- Search section -->
                            <template v-if="tab.display_search_button">
                                <b-button
                                    v-if="!expandedSearch"
                                    variant="outline"
                                    @click="expandedSearch = true"
                                    class="flex-shrink-0"
                                >
                                    <i class="bi bi-search"></i>
                                </b-button>

                                <transition name="slide-fade">
                                    <div v-if="expandedSearch" class="search-container">
                                        <b-form @submit.prevent="onSubmitSearch" class="d-flex">
                                            <b-input-group>
                                                <b-form-input
                                                    v-model="searchQuery"
                                                    :placeholder="$t('common.search_placeholder')"
                                                    class="flex-grow-1"
                                                    style="padding: 0rem 1rem;"
                                                />
                                                <b-input-group-append>
                                                    <b-button type="submit" variant="primary">
                                                        <i class="bi bi-search"></i>
                                                    </b-button>
                                                </b-input-group-append>
                                            </b-input-group>
                                        </b-form>
                                    </div>
                                </transition>
                            </template>

                            <!-- Add new button -->
                            <b-button
                                v-if="displayNewFeedbackButton"
                                variant="primary"
                                @click.prevent="openAddPostModal(defaultNewStatusId, defaultNewSectionId)"
                                class="flex-shrink-0 text-nowrap"
                            >
                                <i class="bi bi-plus-circle"></i>
                                {{ newFeedbackButton }}
                            </b-button>
                        </div>
                    </div>
                </div>

                <template v-if="tab.type === 'kanban'">
                    <div class="d-flex justify-content-end mb-2" v-if="isAdmin && column_names === 'status'">
                        <div class="d-flex align-items-center">
                            <span class="mr-2 small">Auto Notify Voters on Drag Drop</span>
                            <b-form-checkbox @change="toggleAutoNotify" v-model="autoNotifyLocal" switch></b-form-checkbox>
                        </div>
                    </div>

                    <b-alert show variant="info" v-if="!loading && columns.length === 0" class="text-center">
                        No content available yet. Please check back later.
                    </b-alert>

                    <div v-else-if="!loading" class="kanban roadmap_list" :class="getResponsiveClass()">
                        <draggable :disabled="!isAdmin || isSmallScreen" class="lists_container draggable-item" :class="columnClass" :list="columns" group="columns" @end="onColumnDragEnd">
                            <div v-for="(column, index) in columns" class="list" :key="column.id" :id="`column-${column.id}`">


                                <loading v-if="sectionLoading[column.id]"></loading>
                                <div class="cards">
                                    <section-title
                                        v-if="column_names === 'section' && column.posts"
                                        :section="column"
                                        :is-admin="isAdmin"
                                        :can-delete="(column && column.posts && column.posts.length === 0) && column_names === 'section'"
                                        @section-created="handleSectionCreated"
                                        @update-section="handleSectionUpdate"
                                        @delete-section="handleSectionDelete"
                                    ></section-title>

                                    <status-title
                                        v-if="column_names === 'status' && column.posts"
                                        :status="column"
                                        :is-admin="isAdmin"
                                        :can-delete="(column && column.posts && column.posts.length === 0) && column_names === 'status'"
                                        @status-created="handleStatusCreated"
                                        @update-status="handleStatusUpdate"
                                        @delete-status="handleStatusDelete"
                                    ></status-title>
                                    <draggable :disabled="!isAdmin || isSmallScreen" :list="column.posts" group="posts" class=" draggable-item" @end="onPostDragEnd">
                                        <div v-if="isAdmin && column.posts && column.posts.length === 0" class="text-muted text-center small pt-5 pb-5">Drag posts here after status update</div>
                                        <div v-else v-for="post in column.posts" :key="post.id" :id="`post-${post.id}`" class="w-100">
                                            <post-card :post="post" :options="postSettings" :is-admin="isAdmin" @post-deleted="handlePostDelete"></post-card>
                                        </div>
                                        <div v-if="isAdmin && isSmallScreen" class="text-muted text-center small pt-2" style="min-height: 50px;">Expand your screen to enable drag and drop</div>
                                    </draggable>
                                    <div v-if="sectionHasMore[column.id]" class="text-center mt-3">
                                        <b-button @click="loadMorePosts(column.id)" variant="outline" size="sm">{{ $t('common.load_more') }}</b-button>
                                    </div>

                                    <footer class="d-flex justify-content-between mt-3">
                                        <b-button v-if="isAdmin" variant="outline" @click.prevent="openAddPostModal(null, column.id, true)" v-b-tooltip title="Add Post">
                                            <i class="bi bi-plus-circle text-success"></i> Add a post
                                        </b-button>
                                    </footer>
                                </div>
                            </div>

                            <!-- Only show the "Other" column when in section mode -->
                            <div v-if="column_names === 'section' && (columns.length === 0 || (postsWithoutSection && postsWithoutSection.length > 0))" class="list" key="no_section" id="no_section">
                                <section-title
                                    :section="otherSection"
                                    :is-other-section="true"
                                    :is-admin="isAdmin"
                                    :can-delete="false"
                                    @section-created="handleSectionCreated"
                                    @update-section="handleSectionUpdate"
                                    @delete-section="handleSectionDelete"
                                ></section-title>

                                <div class="cards">
                                    <draggable :disabled="!isAdmin || isSmallScreen" :list="postsWithoutSection" group="posts" @end="onPostDragEnd">
                                        <div v-if="isAdmin && postsWithoutSection.length === 0" class="text-muted text-center small pt-5 pb-5">Drag posts here after status update</div>
                                        <div v-for="post in postsWithoutSection" :key="post.id" :id="`post-${post.id}`" class="w-100">
                                            <post-card :post="post" :options="postSettings" :is-admin="isAdmin" @post-deleted="handlePostDelete"></post-card>
                                        </div>
                                        <div v-if="isAdmin && isSmallScreen" class="text-muted text-center small pt-2" style="min-height: 50px;">Expand your screen to enable drag and drop</div>
                                    </draggable>
                                    <div v-if="sectionHasMore[null]" class="text-center mt-3">
                                        <b-button @click="loadMorePosts(null)" variant="outline" size="sm">{{ $t('common.load_more') }}</b-button>
                                    </div>
                                </div>
                                <footer>
                                    <b-button v-if="isAdmin" variant="outline" class="mt-3" @click.prevent="openAddPostModal(defaultNewStatusId, defaultNewSectionId, true)" v-b-tooltip title="Add Post"><i class="bi bi-plus-circle text-success"></i> Add a post</b-button>
                                </footer>
                            </div>
                        </draggable>

                        <div v-if="isAdmin" class="d-flex justify-content-end mt-2">
                            <b-button
                                v-if="tab.type === 'kanban' && column_names === 'section' && !tab.saved_query_id"
                                variant="outline"

                                @click="addSectionAfterId=null;showNewSectionModal = true"
                                v-b-tooltip
                                title="Add section column">
                                <i class="bi bi-layout-sidebar-inset"></i> Add column
                            </b-button>
                            <b-button
                                v-if="tab.type === 'kanban' && column_names === 'status' && !tab.saved_query_id"
                                variant="outline"

                                @click="addSectionAfterId=null;showNewStatusModal = true"
                                v-b-tooltip
                                title="Add status column">
                                <i class="bi bi-layout-sidebar-inset"></i> Add column
                            </b-button>
                        </div>
                    </div>
                </template>

                <template v-else-if="tab.type === 'knowledgebase'">
                    <knowledge-base-view
                        ref="knowledgeBaseView"
                        :tab-id="tab.id"
                        :tab-slug="tab.slug"
                        :is-admin="isAdmin"
                        :post-settings="postSettings"
                        :categories="categories"
                        :status="newStatusId"
                        @open-add-post-modal="openAddPostModal"
                        @post-added="onPostAdded"
                        @post-deleted="handlePostDelete"
                    ></knowledge-base-view>
                </template>

                <template v-else-if="tab.type === 'cards'">
                    <!-- @todo, temp fix for reactivity -->
                    <div style="display: none;">{{postsWithoutSection}}</div>
                    <loading v-if="sectionLoading[null]"></loading>
                    <template v-else>
                        <div v-if="isAdmin && postsWithoutSection.length === 0" class="mx-auto pt-5" style="max-width: 500px;">
                            <b-alert variant="info" show>Add a post by updating an <a href="/admin/posts/all">existing one</a> or <a href="#" variant="link" @click.prevent="openAddPostModal(defaultNewStatusId, defaultNewSectionId, true)">create a new one</a></b-alert>
                        </div>
                        <div v-else-if="postsWithoutSection.length === 0" class="mx-auto pt-5 text-center" style="max-width: 500px;">
                            <b-alert variant="info" show>No posts available.</b-alert>
                        </div>
                        <draggable
                            v-model="postsWithoutSection"
                            :disabled="!this.isAdmin || this.isSmallScreen"
                            class="row"
                            @end="handleListCardsDragEnd"
                        >
                            <div v-for="post in postsWithoutSection"
                                 :key="post.id"
                                 :id="`post-${post.id}`"
                                 class="col-12 col-md-6 col-lg-4 col-xl-4 pb-4"
                            >
                                <post-card :post="post" :options="postSettings" :is-admin="isAdmin" @post-deleted="handlePostDelete"></post-card>
                            </div>
                        </draggable>
                        <div v-if="sectionHasMore[null]" class="text-center mt-3">
                            <b-button @click="loadMorePosts(null)" variant="outline" size="sm">{{ $t('common.load_more') }}</b-button>
                        </div>
                    </template>
                </template>

                <template v-else-if="tab.type === 'list'">
                    <!-- @todo, temp fix for reactivity -->
                    <div style="display: none;">{{postsWithoutSection}}</div>
                    <loading v-if="sectionLoading[null]"></loading>
                    <template v-else>
                        <div v-if="isAdmin && postsWithoutSection.length === 0" class="mx-auto pt-5" style="max-width: 500px;">
                            <b-alert variant="info" show>Add a post by updating an <a href="/admin/posts/all">existing one</a> or <a href="#" variant="link" @click.prevent="openAddPostModal(defaultNewStatusId, defaultNewSectionId, true)">create a new one</a></b-alert>
                        </div>
                        <div v-else-if="postsWithoutSection.length === 0" class="mx-auto pt-5 text-center" style="max-width: 500px;">
                            <b-alert variant="info" show>No posts available.</b-alert>
                        </div>
                        <draggable
                            v-model="postsWithoutSection"
                            :disabled="!this.isAdmin || this.isSmallScreen"
                            @end="handleListCardsDragEnd"
                        >
                            <div v-for="post in postsWithoutSection"
                                 :key="post.id"
                                 :id="`post-${post.id}`"
                            >
                                <post-card like-box-position="left" :post="post" :options="postSettings" :is-admin="isAdmin" @post-deleted="handlePostDelete"></post-card>
                            </div>
                        </draggable>
                        <div v-if="sectionHasMore[null]" class="text-center mt-3">
                            <b-button @click="loadMorePosts(null)" variant="outline" size="sm">{{ $t('common.load_more') }}</b-button>
                        </div>
                    </template>
                </template>

                <template v-else-if="tab.type === 'changelog'">
                    <!-- @todo, temp fix for reactivity -->
                    <div style="display: none;">{{postsWithoutSection}}</div>
                    <loading v-if="sectionLoading[null]"></loading>
                    <template v-else>
                        <div v-if="isAdmin && postsWithoutSection.length === 0" class="mx-auto pt-5" style="max-width: 500px;">
                            <b-alert variant="info" show>Add a post by updating an <a href="/admin/posts/all">existing one</a> or <a href="#" variant="link" @click.prevent="openAddPostModal(defaultNewStatusId, defaultNewSectionId)">create a new one</a></b-alert>
                        </div>
                        <div v-else-if="postsWithoutSection.length === 0" class="mx-auto pt-5 text-center" style="max-width: 500px;">
                            <b-alert variant="info" show>No posts available.</b-alert>
                        </div>
                        <div v-for="post in postsWithoutSection" :key="post.id" :id="`post-${post.id}`">
                            <changelog-card :post="post" :options="postSettings" :is-admin="isAdmin" @post-deleted="handlePostDelete"></changelog-card>
                        </div>
                        <div v-if="sectionHasMore[null]" class="text-center mt-3">
                            <b-button @click="loadMorePosts(null)" variant="outline" size="sm">{{ $t('common.load_more') }}</b-button>
                        </div>
                    </template>
                </template>

            </div>



            <div v-if="tab.display_feedback_form === 'right'" class="d-none d-md-block" style="min-width: 300px; max-width: 400px; margin-left: 30px;">
                <b-card>
                    <h6>{{newFeedbackButton}}</h6>
                    <PostForm :status="newStatusId" :section="newSectionId" :categories="categories" :category="selectedCategoryId" :is-admin="isAdmin" @post-added="onPostAdded" />
                </b-card>
            </div>


        </div>
    </div>
</template>

<script>
import PostCard from './PostCard.vue';
import KnowledgeBaseView from './KnowledgeBaseView.vue';
import ChangelogCard from './ChangelogCard.vue';
import NotificationPop from '../mixins/NotificationPop.js'
import draggable from 'vuedraggable';
import Loading from "./Loading.vue";
import SectionTitle from "./SectionTitle.vue";
import AddPostModal from './AddPostModal.vue';
import CategoryFilterRow
    from "./CategoryFilterRow.vue";
import CategoryFilterColumns
    from "./CategoryFilterColumns.vue";
import { mapState } from 'vuex';
import AddSectionModal
    from "./AddSectionModal";
import TabHandlers
    from "../mixins/TabHandlers";
import PostForm
    from "./PostForm";
import StatusTitle
    from "./StatusTitle";
import AddStatusModal
    from "./AddStatusModal";
import OnboardingFeedbackTab
    from "./OnboardingFeedbackTab";
import OnboardingRoadmapTab
    from "./OnboardingRoadmapTab";
import OnboardingChangelogTab
    from "./OnboardingChangelogTab";
import OnboardingKnowledgebaseTab
    from "./OnboardingKnowledgebaseTab";


export default {
    components: {
        CategoryFilterRow,
        CategoryFilterColumns,
        Loading,
        PostCard,
        ChangelogCard,
        draggable,
        SectionTitle,
        AddPostModal,
        AddSectionModal,
        PostForm,
        KnowledgeBaseView,
        StatusTitle,
        AddStatusModal,
        OnboardingFeedbackTab,
        OnboardingRoadmapTab,
        OnboardingChangelogTab,
        OnboardingKnowledgebaseTab,
    },
    mixins: [NotificationPop, TabHandlers],
    props: {
        dataSlug: {
            type: [String, Number],
            required: true
        }
    },
    data() {
        return {
            column_names: 'status',
            showNewSectionModal: false,
            addSectionAfterId: null,
            showNewStatusModal: false,
            addStatusAfterId: null,
            windowWidth: window.innerWidth,
            loading: true,
            sections: [],
            statuses: [],
            postsWithoutSection: [],
            tab: {},
            categories: {},
            postSettings: {},
            selectedCategoryId: null,
            sectionLoading: {}, // Tracks loading state of each section
            sectionHasMore: {}, // See if we can load more
            currentPage: {},
            newStatusId: null,
            newSectionId: null,
            defaultNewStatusId: null,
            defaultNewSectionId: null,
            otherSection: {
                id: null,
                title: 'Other',
                is_hidden_for_users: false
            },
            expandedSearch: false,
            searchQuery: '',
            postsPerPage: 15, // Pagination
            orderBy: 'created_at', // Default order
            orderDirection: 'desc', // Default direction
            isAdminForm: false,
            newPostModalTitle: 'Add post',
            autoNotifyLocal: false,
            dragQueue: [],
            isProcessingDrag: false,
            selectedVersion: null,
            selectedRelease: null,
            selectedPlatform: null,
            sortOptions: {
                'title': 'Title',
                'created_at': 'Created Date',
                'updated_at': 'Updated Date',
                'votes_count': 'Votes Count',
                'comments_count': 'Comments Count'
            }
        };
    },
    computed: {
        isSmallScreen() {
            return this.windowWidth <= 768;
        },
        isSmallVariant() {
            return this.tab.display_feedback_form === 'left' ||
                this.tab.display_feedback_form === 'right';
        },
        displayFilterRow() {
            return this.tab.display_category_bar_row && !(this.isSmallScreen && this.expandedSearch)
        },
        displayNewFeedbackButton() {
            return this.tab.display_new_post_button && !(this.isSmallScreen && this.expandedSearch)
        },
        columnClass() {
            let count = this.columns.length + ((this.postsWithoutSection && this.postsWithoutSection.length > 0) ? 1 : 0);
            if(this.tab.display_number_columns !== 'auto') {
                count = parseInt(this.tab.display_number_columns, 10);
            }
            return {
                'lists_col_1': count === 1,
                'lists_col_2': count === 2,
                'lists_col_3': count === 3,
                'lists_col_4': count === 4,
                'lists_col_more_4': count > 4,
            };
        },
        otherSectionTitle() {
            return 'Uncategorized'; // Replace with appropriate title
        },
        totalPosts() {
            const sectionPosts = this.sections.reduce((total, section) => total + (section.posts ? section.posts.length : 0), 0);
            const postsWithoutSectionCount = this.postsWithoutSection ? this.postsWithoutSection.length : 0;
            return sectionPosts + postsWithoutSectionCount;
        },
        hasVersions() {
            return this.uniqueVersions.length > 0 && this.tab.display_versions_filter
        },
        hasReleases() {
            return this.uniqueReleases.length > 0 && this.tab.display_releases_filter
        },
        hasPlatforms() {
            return this.uniquePlatforms.length > 0 && this.tab.display_platforms_filter
        },
        ...mapState(['isLoggedIn', 'isAdmin', 'newFeedbackButton', 'autoNotifyVotersOnDragDrop', 'defaultStatusId']),
    },
    mounted() {
        this.init(); // Call the async init method

        this.autoNotifyLocal = this.autoNotifyVotersOnDragDrop

        window.addEventListener('resize', this.updateWindowWidth);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateWindowWidth);
    },
    methods: {
        setVersion(version) {
            this.selectedVersion = version
            this.loadPosts();
        },
        setRelease(release) {
            this.selectedRelease = release
            this.loadPosts();
        },
        setPlatform(platform) {
            this.selectedPlatform = platform
            this.loadPosts();
        },
        getSortIcon() {
            if (this.orderBy === this.tab.default_sorting.by &&
                this.orderDirection === this.tab.default_sorting.direction) {
                return 'bi-sort-down';
            }
            return this.orderDirection === 'asc' ? 'bi-sort-up-alt text-primary' : 'bi-sort-down-alt text-primary';
        },

        getSortDirectionIcon(field) {
            if (this.orderBy !== field) return '';
            return this.orderDirection === 'asc' ? 'bi-arrow-up' : 'bi-arrow-down';
        },
        goToCreateWidget(option) {
            const baseUrl = '/admin/widgets/create_one_click';
            const queryParams = `?tab_id=${this.tab.id}&widget_type=${option}`;
            const fullUrl = baseUrl + queryParams;
            window.location.href = fullUrl; // Redirect to the constructed URL
        },
        onColumnDragEnd(event) {
            if(this.tab.saved_query_id) {
                this.popNotification('Columns on this custom query tab cannot be reordered. They follow the tab sequence and order within them.', 'warning');
                return;
            }

            const columnOrder = this.columns.map(column => column.id).join(',');
            const endpoint = this.column_names === 'section' ? '/http_api/sections/reorder' : '/http_api/statuses/reorder';

            // Send AJAX request to update the order
            this.$http.post(endpoint, {
                order: columnOrder,
                tab_id: this.tab.id
            })
                .then(response => {
                    console.log(`${this.column_names} reordered successfully`, response);

                    this.popNotification('Order updated successfully', 'success');
                    // You might want to update the local state here if needed
                })
                .catch(error => {
                    console.error(`Error reordering ${this.column_names}`, error);
                    // Handle the error (e.g., show an error message to the user)
                    this.popNotification(`Failed to reorder ${this.column_names}. Please try again.`, 'danger');

                    // Optionally, revert the change in the UI
                    // This would require keeping a backup of the original order
                });
        },

        onPostDragEnd(event) {
            this.dragQueue.push(event);
            this.processDragQueue();
        },
        async processDragQueue() {
            // If we are already processing a drag event, exit
            if (this.isProcessingDrag || this.dragQueue.length === 0) return;

            // Set the flag to indicate processing has started
            this.isProcessingDrag = true;

            // Get the first event from the queue
            const event = this.dragQueue.shift();

            try {
                // Extract relevant data from the event
                const postElement = event.item;
                const postId = postElement.id.replace('post-', '');

                let columnElement = event.to;
                if (!columnElement.classList.contains('list')) {
                    columnElement = columnElement.closest('.list');
                }
                const columnId = parseInt(columnElement.id.replace('column-', ''));
                const newIndex = event.newIndex;

                if(!columnId) {
                    this.popNotification('You cannot reorder the Uncategorized column', 'danger')
                    return;
                }

                // Call your existing function to update the columns and posts
                await this.updateColumnsAndPosts(columnId, postId, newIndex);
            } catch (error) {
                // Handle any errors that occurred during processing
                console.error('Error processing drag event:', error);
            } finally {
                // Mark that processing is done
                this.isProcessingDrag = false;

                // If there are more events in the queue, process the next one
                if (this.dragQueue.length > 0) {
                    this.processDragQueue();
                }
            }
        },
        async updateColumnsAndPosts(columnId, postId, newIndex) {
            const numericColumnId = typeof columnId === 'string' ? parseInt(columnId, 10) : columnId;
            let movedPost = null;
            let sourceColumn = null;

            // Find and remove the post from its current column
            for (let i = 0; i < this.columns.length; i++) {
                const column = this.columns[i];
                const postIndex = column.posts.findIndex(post => post.id === postId);
                if (postIndex !== -1) {
                    sourceColumn = column;
                    movedPost = column.posts.splice(postIndex, 1)[0];
                    break;
                }
            }

            // Handle posts in the "Other" category if not found in any columns
            if (!movedPost && this.column_names === 'section' && this.postsWithoutSection) {
                const postIndex = this.postsWithoutSection.findIndex(post => post.id === postId);
                if (postIndex !== -1) {
                    sourceColumn = null; // Indicates post was from "Other"
                    movedPost = this.postsWithoutSection.splice(postIndex, 1)[0];
                }
            }

            // If we couldn't find the post, return early
            if (!movedPost) {
                console.error(`Could not find post with id ${postId}`);
                return;
            }

            // Determine the target column or "Other" category
            let targetColumn = this.columns.find(column => column.id === numericColumnId);

            if (numericColumnId === null && this.column_names === 'section') {
                // Handle case when moved to "Other"
                targetColumn = null;
                this.postsWithoutSection.splice(newIndex, 0, movedPost);
            } else if (targetColumn) {
                // Handle case when moved to a regular column
                targetColumn.posts.splice(newIndex, 0, movedPost);
                if (this.column_names === 'section' && this.postsWithoutSection) {
                    // Ensure it is removed from "Other" if it was there
                    const indexInWithoutSection = this.postsWithoutSection.findIndex(post => post.id === postId);
                    if (indexInWithoutSection !== -1) {
                        this.postsWithoutSection.splice(indexInWithoutSection, 1);
                    }
                }
            } else {
                console.error(`Could not find target column with id ${numericColumnId}`);
                return;
            }

            // Generate the new post order for the target column or "Other"
            let postOrder = '';
            if (targetColumn && Array.isArray(targetColumn.posts)) {
                postOrder = targetColumn.posts.map(post => post.id).join(',');
            } else if (targetColumn === null && this.column_names === 'section') {
                postOrder = this.postsWithoutSection.map(post => post.id).join(',');
            }

            // Set loading state
            this.setPostLoadingState(postId, true);

            // Prepare the payload for the API call
            const payload = {
                post_key: postId,
                post_order: postOrder
            };

            // Add appropriate identifier for section or status
            if (this.column_names === 'section') {
                payload.section_id = numericColumnId;
            } else {
                payload.status_id = numericColumnId;
            }

            try {
                // Update the backend with the new order
                await this.$http.post('/http_api/posts/reorder', payload);

                // Fetch the updated post details
                const response = await this.$http.get(`/http_api/posts/${postId}`);

                // Update the post in the correct place
                this.updatePostInColumns(response.data.data, postId);
            } catch (error) {
                console.error('Error reordering posts', error);

                // Revert the move if an error occurs
                this.revertPostMove(sourceColumn, targetColumn, movedPost, newIndex);
            } finally {
                // Clear the loading state
                this.setPostLoadingState(postId, false);
            }
        },

        revertPostMove(sourceColumn, targetColumn, movedPost, newIndex) {
            if (this.column_names === 'section' && sourceColumn === null) {
                // Post was moved from postsWithoutSection to a column
                targetColumn.posts.splice(targetColumn.posts.findIndex(p => p.id === movedPost.id), 1);
                this.postsWithoutSection.splice(newIndex, 0, movedPost);
            } else if (this.column_names === 'section' && targetColumn === null) {
                // Post was moved from a column to postsWithoutSection
                this.postsWithoutSection.splice(this.postsWithoutSection.findIndex(p => p.id === movedPost.id), 1);
                sourceColumn.posts.splice(newIndex, 0, movedPost);
            } else {
                // Post was moved between columns
                targetColumn.posts.splice(targetColumn.posts.findIndex(p => p.id === movedPost.id), 1);
                sourceColumn.posts.splice(newIndex, 0, movedPost);
            }
        },

        setPostLoadingState(postId, isLoading) {
            this.columns.forEach(column => {
                const post = column.posts.find(p => p.id === postId);
                if (post) {
                    this.$set(post, 'loading', isLoading);
                }
            });

            if (this.column_names === 'section') {
                const postWithoutSection = this.postsWithoutSection.find(p => p.id === postId);
                if (postWithoutSection) {
                    this.$set(postWithoutSection, 'loading', isLoading);
                }
            }
        },

        updatePostInColumns(updatedPost, postId) {
            // Update the post in its new column
            for (const column of this.columns) {
                const postIndex = column.posts.findIndex(post => post.id === postId);
                if (postIndex !== -1) {
                    this.$set(column.posts, postIndex, updatedPost);
                    return;
                }
            }

            // If the post is not found in any column, check postsWithoutSection (only in section mode)
            if (this.column_names === 'section') {
                const postIndexWithoutSection = this.postsWithoutSection.findIndex(post => post.id === postId);
                if (postIndexWithoutSection !== -1) {
                    this.$set(this.postsWithoutSection, postIndexWithoutSection, updatedPost);
                }
            }
        },

        onCategorySelected(category) {
            if(category === null) {
                this.filterCategory(null)
            } else {
                // Double click, disable
                if(this.selectedCategoryId === category.id) {
                    this.filterCategory(null)
                } else {
                    this.filterCategory(category.id)
                }
            }
        },
        handleStatusUpdate(updatedStatus) {
            const index = this.statuses.findIndex(status => status.id === updatedStatus.id);

            if (index !== -1) {
                this.statuses.splice(index, 1, updatedStatus);

                // Reload posts for this status
                this.sectionLoading[updatedStatus.id] = true;
                this.fetchPostsForColumn(updatedStatus.id);
            }
        },
        handleSectionUpdate(updatedSection) {
            const index = this.sections.findIndex(section => section.id === updatedSection.id);

            if (index !== -1) {
                this.sections.splice(index, 1, updatedSection);

                // Reload posts for this section
                this.sectionLoading[updatedSection.id] = true;
                this.fetchPostsForColumn(updatedSection.id);
            }
        },
        handleSectionDelete(sectionId) {
            const sectionIndex = this.sections.findIndex(section => section.id === sectionId);
            if (sectionIndex !== -1) {
                // Ensure postsFromDeletedSection is an array
                const postsFromDeletedSection = Array.isArray(this.sections[sectionIndex].posts)
                    ? this.sections[sectionIndex].posts
                    : [];

                // Ensure postsWithoutSection is an array before spreading
                this.postsWithoutSection = Array.isArray(this.postsWithoutSection)
                    ? [...this.postsWithoutSection, ...postsFromDeletedSection]
                    : [...postsFromDeletedSection];

                // Remove the section
                this.sections.splice(sectionIndex, 1);
            }
        },
        handleNewSectionCreatedButton(newSection) {
            this.handleSectionCreated(newSection, this.addSectionAfterId);
            this.showNewSectionModal = false;
            this.addSectionAfterId = null; // Reset the addSectionAfterId
        },
        handleSectionCreated(newSection, afterSectionId) {
            let insertIndex;
            if (afterSectionId === null) {
                // If afterSectionId is null, add to the end
                insertIndex = this.sections.length;
            } else {
                // Find the index of the section after which to insert
                const afterIndex = this.sections.findIndex(s => s.id === afterSectionId);
                insertIndex = afterIndex !== -1 ? afterIndex + 1 : this.sections.length;
            }

            // Insert the new section at the correct position
            this.$set(newSection, 'posts', []);
            this.sections.splice(insertIndex, 0, newSection);
        },

        openAddPostModal(param1 = null, param2 = null, isAdminForm = false) {
            this.isAdminForm = isAdminForm;

            if (isAdminForm) {
                this.newPostModalTitle = 'Add post';
            } else {
                this.newPostModalTitle = this.newFeedbackButton;
            }

            let statusId, sectionId;

            // Determine which parameter is which based on the current display mode
            if (this.column_names === 'status') {
                statusId = param1 !== null ? param1 : (param2 !== null ? param2 : this.defaultNewStatusId);
                sectionId = this.defaultNewSectionId;
            } else {
                sectionId = param2 !== null ? param2 : (param1 !== null ? param1 : this.defaultNewSectionId);
                statusId = this.defaultNewStatusId;
            }

            // If we're adding from a specific column (param1 is null, param2 is the column.id)
            if (param1 === null && param2 !== null) {
                if (this.column_names === 'status') {
                    statusId = param2;
                } else {
                    sectionId = param2;
                }
            }

            // Ensure we have valid IDs
            this.newStatusId = statusId !== null ? statusId : this.defaultNewStatusId;
            this.newSectionId = sectionId !== null ? sectionId : this.defaultNewSectionId;

            // If we're in status mode and still don't have a valid status, try to use the first column
            if (this.column_names === 'status' && this.newStatusId === null && this.columns.length > 0) {
                this.newStatusId = this.columns[0].id;
            }

            // If we're in section mode and still don't have a valid section, try to use the first column
            if (this.column_names === 'section' && this.newSectionId === null && this.columns.length > 0) {
                this.newSectionId = this.columns[0].id;
            }

            this.$refs.addPostModal.isModalVisible = true;
        },
        onPostAdded(newPost) {
            let addedToColumn = null;

            if (this.column_names === 'status') {
                const statusId = newPost.status && newPost.status.id ? newPost.status.id : null;
                const statusIndex = this.statuses.findIndex(status => status.id === statusId);

                if (statusIndex !== -1) {
                    if (!this.statuses[statusIndex].posts) {
                        this.$set(this.statuses[statusIndex], 'posts', []);
                    }
                    // Add to the top or bottom of the list based on tab type
                    if (this.tab.type === 'changelog') {
                        this.statuses[statusIndex].posts.unshift(newPost); // Add to the top
                    } else {
                        this.statuses[statusIndex].posts.push(newPost); // Add to the bottom
                    }
                    this.$nextTick(() => {
                        this.highlightAndScrollToNewPost(newPost.id, this.statuses[statusIndex]);
                    });
                } else if (this.statuses.length > 0) {
                    if (!this.statuses[0].posts) {
                        this.$set(this.statuses[0], 'posts', []);
                    }
                    // Add to the top or bottom of the default status
                    if (this.tab.type === 'changelog') {
                        this.statuses[0].posts.unshift(newPost); // Add to the top
                    } else {
                        this.statuses[0].posts.push(newPost); // Add to the bottom
                    }
                    setTimeout(() => {
                        this.highlightAndScrollToNewPost(newPost.id, this.statuses[0]);
                    }, 300);
                }
            } else {
                const sectionIndex = this.sections.findIndex(section => section.id === newPost.section_id);
                if (sectionIndex !== -1) {
                    addedToColumn = this.sections[sectionIndex];
                    if (!addedToColumn.posts) {
                        this.$set(addedToColumn, 'posts', []);
                    }
                    // Add to the top or bottom of the list based on tab type
                    if (this.tab.type === 'changelog') {
                        addedToColumn.posts.unshift(newPost); // Add to the top
                    } else {
                        addedToColumn.posts.push(newPost); // Add to the bottom
                    }
                } else {
                    if (!this.postsWithoutSection) {
                        this.postsWithoutSection = [];
                    }
                    // Add to the top or bottom of the uncategorized posts
                    if (this.tab.type === 'changelog') {
                        this.postsWithoutSection.unshift(newPost); // Add to the top
                    } else {
                        this.postsWithoutSection.push(newPost); // Add to the bottom
                    }
                }
            }

            setTimeout(() => {
                this.highlightAndScrollToNewPost(newPost.id, addedToColumn);
            }, 300);
        },


        highlightAndScrollToNewPost(postId, column) {
            const postElement = document.getElementById(`post-${postId}`);

            if (postElement) {
                postElement.classList.add('highlight-new-post');

                // Find the nearest scrollable parent
                let scrollableParent = postElement.closest('.cards') || postElement.closest('.list');

                if (scrollableParent) {
                    // Scroll into view without manual scrollTop calculation
                    postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                } else {
                    // If no scrollable parent found, use scrollIntoView as the default
                    postElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }

                setTimeout(() => {
                    postElement.classList.remove('highlight-new-post');
                }, 5000);
            } else {
                console.log('Post element not found to highlight');
            }
        },



        /**
         *  Ideally, for a Kanban board, you should aim to minimize the number of requests. A single API request that fetches all necessary data (tab configuration, sections, posts within each section, and categories for filtering) is typically more efficient. This approach reduces the number of server round trips, leading to faster initial rendering of the Kanban board.
         *  We make two, because first we get all settings and such, then we load posts
         */
        loadTab() {
            return this.$http.get(`/http_api/tabs/${this.dataSlug}/fetch`)
                .then(({data}) => {
                    this.tab = data.tab
                    this.sections = data.sections
                    this.categories = data.categories
                    this.statuses = data.statuses
                    this.postSettings = this.tab
                    this.otherSection.tab_id = this.tab.id
                    this.otherSection.title = this.otherSectionTitle
                    this.column_names = data.tab.column_names

                    this.uniqueVersions = data.versions
                    this.uniqueReleases = data.releases
                    this.uniquePlatforms = data.platforms

                    if(this.statuses.length === 0) {
                        this.popNotification('The query has returned zero results', 'danger')
                    }

                    // Keep the section if it's not hidden or if the user is an admin
                    this.sections = data.sections.filter(section => {
                        return !section.is_hidden_for_users || this.isAdmin;
                    });
                })
                .catch(error => {
                    this.loading = true;
                    console.log(error)
                    this.popNotification('Something went wrong on our side. Could not load posts. Please try again or contact ruben@productlift.dev', 'danger')
                });
        },

        reloadStatuses() {
            return this.$http.get(`/http_api/tabs/${this.dataSlug}/fetch`)
                .then(({data}) => {
                    this.statuses = data.statuses
                })
                .catch(error => {
                    this.loading = true;
                    console.log(error)
                    this.popNotification('Something went wrong on our side. Could not load posts. Please try again or contact ruben@productlift.dev', 'danger')
                });
        },
        getResponsiveClass() {
            let mode = this.tab.responsive_mode
            return {
                'kanban_responsive_horizontal': mode === 'horizontal',
                'kanban_responsive_vertical': mode === 'vertical'
            };
        },
        handleStatusCreated(newStatus, afterStatusId) {
            let insertIndex;
            if (afterStatusId === null) {
                // If afterStatusId is null, add to the end
                insertIndex = this.statuses.length;
            } else {
                // Find the index of the status after which to insert
                const afterIndex = this.statuses.findIndex(s => s.id === afterStatusId);
                insertIndex = afterIndex !== -1 ? afterIndex + 1 : this.statuses.length;
            }

            // Insert the new status at the correct position
            this.$set(newStatus, 'posts', []);
            this.statuses.splice(insertIndex, 0, newStatus);
        },

        handleStatusDelete(statusId) {
            const statusIndex = this.statuses.findIndex(status => status.id === statusId);
            if (statusIndex !== -1) {
                const deletedStatus = this.statuses[statusIndex];
                const postsFromDeletedStatus = Array.isArray(deletedStatus.posts) ? deletedStatus.posts : [];

                // Move posts to default status or postsWithoutStatus
                if (this.defaultStatusId) {
                    const defaultStatusIndex = this.statuses.findIndex(status => status.id === this.defaultStatusId);
                    if (defaultStatusIndex !== -1) {
                        this.statuses[defaultStatusIndex].posts = Array.isArray(this.statuses[defaultStatusIndex].posts)
                            ? [...this.statuses[defaultStatusIndex].posts, ...postsFromDeletedStatus]
                            : [...postsFromDeletedStatus];
                    }
                } else {
                    this.postsWithoutStatus = Array.isArray(this.postsWithoutStatus)
                        ? [...this.postsWithoutStatus, ...postsFromDeletedStatus]
                        : [...postsFromDeletedStatus];
                }

                // Remove the status
                this.statuses.splice(statusIndex, 1);
            }
        },
        toggleAutoNotify(newValue) {
            this.autoNotifyLocal = newValue;
            this.$http.patch('/http_api/portal', {
                auto_notify_voters_on_drag_drop: newValue
            })
                .then(() => {
                    this.popNotification(`Auto-notification has been ${newValue ? 'enabled' : 'disabled'}!`, 'success');
                })
                .catch(error => {
                    console.error('Error updating portal setting:', error);
                    this.popNotification('Failed to update auto-notification. Please try again.', 'danger');
                    // Revert local state on error
                    this.autoNotifyLocal = !newValue;
                });
        },
        handlePostDelete(postId) {
            // Loop through columns to find and remove the post
            this.columns.forEach(column => {
                const postIndex = column.posts.findIndex(post => post.id === postId);
                if (postIndex !== -1) {
                    column.posts.splice(postIndex, 1);
                    this.popNotification('Post deleted successfully!', 'success');
                }
            });

            // Also handle the case where the post is in the "Other" column when no section is found
            if (this.column_names === 'section' && this.postsWithoutSection) {
                const postIndex = this.postsWithoutSection.findIndex(post => post.id === postId);
                if (postIndex !== -1) {
                    this.postsWithoutSection.splice(postIndex, 1);
                    this.popNotification('Post deleted successfully!', 'success');
                }
            }
        },
        copyLink(url) {
            navigator.clipboard.writeText(url).then(() => {
                this.popNotification('Link copied to clipboard', 'success');
            });
        },

        async handleListCardsDragEnd(event) {
            if(this.tab.saved_query_id) {
                this.popNotification('Posts on this custom query tab are ordered by the tab settings ordering.', 'warning');
                return;
            }

            // Don't process if no actual change
            if (event.oldIndex === event.newIndex) return;

            const postOrder = this.postsWithoutSection.map(post => post.id).join(',');

            try {
                // Update backend with new order
                await this.$http.post('/http_api/posts/reorder', {
                    post_key: this.postsWithoutSection[event.newIndex].id,
                    post_order: postOrder,
                    // section_id: null,
                    // status_id: null
                });

                // Show success notification
                this.popNotification('Post order updated successfully', 'success');
            } catch (error) {
                console.error('Error reordering posts:', error);
                this.popNotification('Failed to update post order. Please try again.', 'danger');

                // Revert the change in the UI
                const movedItem = this.postsWithoutSection.splice(event.newIndex, 1)[0];
                this.postsWithoutSection.splice(event.oldIndex, 0, movedItem);
            }
        },
        async handleOnboardingDone(key) {
            try {
                await this.$http.patch(`/http_api/tabs/${this.tab.id}/onboarding`, {
                    key: key,
                    status: 1, // Done
                });
            } catch (error) {
                console.error(`Error marking onboarding step ${key} as done:`, error);
            }
        },
        async handleOnboardingDismissed(key) {
            try {
                await this.$http.patch(`/http_api/tabs/${this.tab.id}/onboarding`, {
                    key: key,
                    status: -1, // Dismissed
                });
            } catch (error) {
                console.error(`Error dismissing onboarding step ${key}:`, error);
            }
        },
        openUrl(url) {
            window.location.href = url;
        },
        addKnowledgeBaseTopic() {
            this.$refs.knowledgeBaseView.showModal(null);
        }

    },
}
</script>

<style scoped>
.filter-bar {
/* Add min-width to prevent tiny unusable buttons */
.b-dropdown {
    min-width: 120px;
}

/* Ensure proper spacing between wrapped items */
.gap-2 {
    gap: 0.5rem !important;
}

/* Handle search transition */
.slide-fade-enter-active {
    transition: all 0.3s ease;
}

.slide-fade-leave-active {
    transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter-from,
.slide-fade-leave-to {
    transform: translateX(10px);
    opacity: 0;
}

/* Ensure search container doesn't overflow */
.search-container {
    max-width: 300px;

@media (max-width: 768px) {
    max-width: 100%;
}
}
}
</style>
<style scoped>
    .tab-buttons-header .bi::before {
        display: inline;
    }
    .draggable-item:active {
        cursor: grabbing;
    }


</style>
<style>
    /* Fix for breaking bar */
    #tabCategoryBar button:first-of-type,
    #tabCategoryDropdown button:first-of-type,
    #tabSortDropdown button:first-of-type {
        white-space: nowrap !important;
    }
    @keyframes highlightFlash {
        0%, 100% { background-color: inherit; }
        50% { background-color: rgba(255, 255, 153, 0.7); }
    }

    .highlight-new-post, .highlight-new-post .changelog-row, .highlight-new-post .hover-card {
        animation: highlightFlash 1s ease-out 3;
    }

</style>
